<template>
  <Modal variant="site-keyword-analysis" @close="close">
    <template slot="title">
      絞り込み条件の保存
    </template>
    <template slot="content">
      <div class="c-fieldset">
        <p class="c-fieldset__header">
          <span class="c-fieldset__title">絞り込み条件名を入力</span>
        </p>
        <div class="c-fieldset__content c-alertPos">
          <Input
            name="filterName"
            v-model="filterName"
            placeholder="（例）絞り込み条件1"
            @focusout="focusout"
          />
          <Alert v-if="isLengthError">
            絞り込み条件名は{{ limit.maxNameLength }}文字以内にしてください
          </Alert>
        </div>
        <div class="c-fieldset__btn c-alertPos">
          <Button
            variant="main"
            size="w240"
            fsize="f16"
            :disabled="!filterName || isLengthError"
            @click="submit"
          >
            保存する
          </Button>
          <Alert v-if="submitErrorMessage">
            {{ submitErrorMessage }}
          </Alert>
        </div>
      </div>
      <p class="c-text--note">
        ※保存した絞り込み条件はご使用の端末・ブラウザでのみ保持されます
      </p>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import utils from '@/utils';
import { v4 as uuidv4 } from 'uuid';
import { FILTER_LIMIT_VALUES } from '@/constants';

export default {
  props: {
    filter: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Input,
    Modal
  },

  data() {
    return {
      filterName: '',
      limit: {
        // 絞り込み条件名の文字数の上限
        maxNameLength: FILTER_LIMIT_VALUES.maxNameLength,
        maxFilterLength: FILTER_LIMIT_VALUES.maxFilterLength
      },
      submitErrorMessage: '',
      status: this.$store.state.page.siteKeywordAnalysis
    };
  },

  computed: {
    isLengthError() {
      return this.filterName.length > this.limit.maxNameLength;
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },
    focusout() {
      this.filterName = this.$options.filters.normalizeAllSpaces(
        this.filterName
      );
    },
    submit() {
      // 上限数を超えているかチェック。複数タブ操作対策でこちらでもチェックする。
      this.checkLimit();
      if (this.submitErrorMessage) {
        return;
      }
      const filterValue = Object.assign({}, this.filter);
      let filterItem = {
        id: uuidv4(),
        name: this.filterName,
        date: utils.formatDate(Date.now(), 'YYYY-MM-DD'),
        value: filterValue
      };
      if (!this.status[this.project.id]) {
        this.status[this.project.id] = {
          filter: [filterItem]
        };
      } else if (!this.status[this.project.id].filter) {
        this.status[this.project.id].filter = [filterItem];
      } else {
        this.status[this.project.id].filter.push(filterItem);
      }
      try {
        this.setStatus(this.status);
      } catch {
        this.submitErrorMessage =
          '容量が不足しているため保存できませんでした。';
        return;
      }
      this.close();
    },
    checkLimit() {
      if (
        this.$store.state.page.siteKeywordAnalysis[this.project.id] &&
        this.$store.state.page.siteKeywordAnalysis[this.project.id].filter &&
        this.$store.state.page.siteKeywordAnalysis[this.project.id].filter
          .length >= this.limit.maxFilterLength
      ) {
        this.submitErrorMessage =
          '保存できる絞り込み条件は最大' +
          this.limit.maxFilterLength +
          '件です';
      }
    },
    setStatus(status) {
      this.$store.dispatch('page/setStatus', {
        page: 'siteKeywordAnalysis',
        status: status
      });
    }
  }
};
</script>
